'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _seoComponent = require('./seo-component');

var _seoComponent2 = _interopRequireDefault(_seoComponent);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _evernote_logo_white = require('landing-pages/assets/evernote_logo_white.svg');

var _evernote_logo_white2 = _interopRequireDefault(_evernote_logo_white);

var _clouds_evernote = require('landing-pages/assets/clouds_evernote.svg');

var _clouds_evernote2 = _interopRequireDefault(_clouds_evernote);

var _cloud_left = require('landing-pages/assets/cloud_left.svg');

var _cloud_left2 = _interopRequireDefault(_cloud_left);

var _cloud_right = require('landing-pages/assets/cloud_right.svg');

var _cloud_right2 = _interopRequireDefault(_cloud_right);

var _folder_icon = require('landing-pages/assets/folder_icon.svg');

var _folder_icon2 = _interopRequireDefault(_folder_icon);

var _signature_icon = require('landing-pages/assets/signature_icon.svg');

var _signature_icon2 = _interopRequireDefault(_signature_icon);

var _cloud_icon = require('landing-pages/assets/cloud_icon.svg');

var _cloud_icon2 = _interopRequireDefault(_cloud_icon);

var _screenshot_evernote = require('landing-pages/assets/screenshot_evernote.png');

var _screenshot_evernote2 = _interopRequireDefault(_screenshot_evernote);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _quoteSection = require('landing-pages/components/common/quote-section');

var _quoteSection2 = _interopRequireDefault(_quoteSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _howItWorksSection = require('landing-pages/components/common/how-it-works-section');

var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_SEOComponent) {
    _inherits(Evernote, _SEOComponent);

    function Evernote() {
        _classCallCheck(this, Evernote);

        return _possibleConstructorReturn(this, (Evernote.__proto__ || Object.getPrototypeOf(Evernote)).apply(this, arguments));
    }

    _createClass(Evernote, [{
        key: 'render',
        value: function render() {
            // Evernote constants
            var benefits = [{
                icon: _folder_icon2['default'],
                title: 'Access Evernote notebooks in your HelloSign account',
                text: 'View documents from your Evernote notebooks in your HelloSign account. Select a note and you’re all set to start preparing your doc for signature.'
            }, {
                icon: _signature_icon2['default'],
                title: 'Send notes for signature request in HelloSign',
                text: 'Prepare your notes for signature with a few quick clicks. Send your signature request and you’re almost there!'
            }, {
                icon: _cloud_icon2['default'],
                title: 'Automatically sync signed documents in your Evernote notebook',
                text: 'Once your document is signed, a copy of the completed document will sync to your Evernote account. Easy storage.'
            }];
            var howItWorks = ['To sync your HelloSign account with Evernote, just click the Evernote icon the next time you upload a document to be signed.', 'Once you are synced, you can click on the Evernote icon whenever you need to pull a file from your Evernote account to request a signature or sign and send.'];
            var twitterLink = 'https://twitter.com/intent/tweet?text=Integrate%20%40Evernote%20with%20%40HelloSign%20to%20easily%20import%20notes%20and%20store%20signed%20documents%20in%20%23Evernote.&url=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dtwitter%26utm_campaign%3Devernote-integration-page-s2s';
            var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dfacebook%26utm_campaign%3Devernote-integration-page-s2s';
            var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.hellosign.com%2Fevernote%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin%26utm_campaign%3Devernote-integration-page-s2s&title=Integrate%20Evernote%20%26%20HelloSign%20to%20easily%20import%20notes%20and%20store%20signed%20docs%20in%20Evernote&source=https%253A%252F%252Fwww.hellosign.com%252Fevernote';

            return _react2['default'].createElement(
                'div',
                { className: 'seo-cloud-integrations' },
                _react2['default'].createElement(IllustrationArea, { button: this.renderSignupButton() }),
                _react2['default'].createElement(
                    'div',
                    { className: 'seo-cloud-integrations__main' },
                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top' }),
                    _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
                    _react2['default'].createElement(_howItWorksSection2['default'], {
                        image: _screenshot_evernote2['default'],
                        explanation: howItWorks }),
                    _react2['default'].createElement(_quoteSection2['default'], {
                        quote: 'We\'re particularly excited about our partnership with HelloSign because we both believe in the importance of a simple, yet powerful user experience.',
                        name: 'MEGHAN KEANEY ANDERSON',
                        title: 'Product Marketing Director at HubSpot' }),
                    _react2['default'].createElement(_socialSection2['default'], {
                        twitterLink: twitterLink,
                        facebookLink: facebookLink,
                        linkedInLink: linkedInLink }),
                    _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/200998238-Evernote' }),
                    _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom' })
                )
            );
        }
    }]);

    return Evernote;
}(_seoComponent2['default']);

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row evernote-green' },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _evernote_logo_white2['default'], alt: 'Dropbox Logo', className: 'dropbox-logo', width: '130' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Access Evernote Documents in HelloSign'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'Use the HelloSign + Evernote integration to access notes in HelloSign and store copies of signed documents in your Evernote account.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'signup-button' },
                p.button
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _clouds_evernote2['default'], alt: 'cloud left' })
        ),
        _react2['default'].createElement('img', { src: _cloud_left2['default'], alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _cloud_right2['default'], alt: 'cloud right', className: 'cloud-right' })
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/evernote.jsx
 ** module id = 1255
 ** module chunks = 0
 **/